import React, { useEffect, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Tooltip,
  Typography,
  Dialog,
  Button,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import ClientInfoForm from "../../../components/clientInfoForm/ClientInfoForm";
import { useFetch } from "../../../features/customHooks/useFetch";

const useStyles = makeStyles((theme) => ({
  title: { fontWeight: "bold", fontSize: 15 },
  value: { fontSize: 15, marginLeft: 5 },
}));

const ClientInfo = (props) => {
  const classes = useStyles();
  const { data } = props;
  const { loading = true, valuation = [], regetValuation } = data;

  const clientInfoRef = useRef(null);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const handleOpenDialog = () => setEditDialogOpen(true);
  const handleCloseDialog = () => setEditDialogOpen(false);

  const [updateFetchState, setUpdateFetchParams] = useFetch();

  const onSubmitForm = (data, event) => {
    console.log(data);
    const params = {
      method: "put",
      url: "/valuation/" + valuation?.id,
      data: data,
    };
    setUpdateFetchParams(params);
  };

  useEffect(() => {
    if (!updateFetchState.loading && !updateFetchState.error && updateFetchState.data) {
      handleCloseDialog();
      regetValuation();
    }

    if (!updateFetchState.loading && updateFetchState.error) {
      console.log("error");
    }
  }, [updateFetchState]);

  return (
    <Paper style={{ padding: 10 }}>
      <Grid container alignItems='center'>
        <Typography variant='h6' style={{ fontWeight: "bold" }}>
          اطلاعات مشتری
        </Typography>

        <div style={{ flexGrow: 1 }} />

        {valuation?.can_edit && (
          <Tooltip title='ویرایش'>
            <IconButton onClick={handleOpenDialog}>
              <Edit />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
      {loading ? (
        <Grid container alignItems='center' justifyContent='center'>
          <CircularProgress style={{ color: "#757575" }} />
        </Grid>
      ) : (
        <Grid container direction='row'>
          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>نام:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.first_name?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>نام خانوادگی:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.last_name?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>شماره تماس:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.phone_number?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3}>
            <Grid container direction='row' justifyContent='flex-start' alignItems='center' style={{ marginTop: 15 }}>
              <Typography className={classes.title}>جنسیت:</Typography>

              <Typography color='textSecondary' className={classes.value}>
                {valuation?.gender?.toString()?.toPersianDigits()}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

      {valuation?.can_edit && (
        <Dialog open={editDialogOpen} maxWidth={"md"} fullWidth>
          <DialogTitle>ویرایش اطلاعات مشتری</DialogTitle>
          <DialogContent>
            <ClientInfoForm
              ref={clientInfoRef}
              onSubmitForm={onSubmitForm}
              defaultValues={{
                first_name: valuation?.first_name,
                last_name: valuation?.last_name,
                phone_number: valuation?.phone_number,
                gender: valuation?.gender,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>لغو</Button>
            <Button variant='contained' color='primary' onClick={() => clientInfoRef.current.submit()}>
              {updateFetchState?.loading ? <CircularProgress size={23} color='inherit' /> : "ویرایش"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Paper>
  );
};

export default ClientInfo;
